import { defineComponent, computed, ref, watch, onMounted } from 'vue';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiValueBar",
  props: {
    value: { type: Number, required: true },
    maxValue: { type: Number, required: false, default: 100 },
    displayValue: { type: [Number, String], required: false },
    barDirection: { type: String, required: false },
    barColor: { type: String, required: false }
  },
  setup(__props) {
    const props = __props;
    const WIDTH_VALUE = 100;
    const barDirectionClass = computed(() => {
      if (!props.barDirection) {
        return null;
      }
      const baseClass = "fds-ui-value-bar--";
      return baseClass + props.barDirection;
    });
    const barColorClass = computed(() => {
      if (props.barColor) {
        return props.barColor;
      }
      const baseClass = "fds-ui-value-bar";
      const modifier = props.value >= 0 ? "--positive" : "--negative";
      return baseClass + modifier;
    });
    const barWidth = computed(() => {
      const number = Math.abs(props.value * WIDTH_VALUE / props.maxValue);
      const width = number ? number : 0;
      return width > WIDTH_VALUE ? WIDTH_VALUE : width;
    });
    const valueNow = computed(() => {
      return barWidth.value.toFixed(2);
    });
    const valueBar = ref();
    const updateBarWidth = () => {
      if (!valueBar.value) {
        return;
      }
      valueBar.value.style.width = `${barWidth.value}%`;
    };
    watch(barWidth, updateBarWidth);
    onMounted(() => {
      updateBarWidth();
    });
    return { __sfc: true, WIDTH_VALUE, props, barDirectionClass, barColorClass, barWidth, valueNow, valueBar, updateBarWidth };
  }
});

export { _sfc_main as default };
